<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
        <div class="fixed-top-menu">
          <div class="pull-right">
            <router-link class="btn btn-primary" :to="{ path: '/user/edit' }"><i class="fa fa-plus"></i>Új felhasználó</router-link>
          </div>
        </div>
      </div>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li>Felhasználók</li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Felhasználók</h1>
          </div>
          <div class="content-panel-top-btn-group">
            <router-link class="btn btn-primary" :to="{ path: '/user/edit' }"><i class="fa fa-plus"></i>Új felhasználó</router-link>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Felhasználók</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Felhasználó név</th>
                        <th>Név</th>
                        <th>Email</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user in users">
                        <td>{{user.id}}</td>
                        <td>{{user.username}}</td>
                        <td>{{user.fullname}}</td>
                        <td>{{user.email}}</td>
                        <td>
                          <ul class="icon-list">
                            <li class="dropdown"><a class="dropdown-toggle" href="javascript:void(0)"><i class="fa fa-gear"></i></a>
                              <ul class="dropdown-menu">
                                <li class="dropdown-header">Opciók</li>
                                <li><router-link :to="{ path: '/user/edit/', query: { userID: user.id }}"><i class="fa fa-pencil-square-o"></i>Szerkeszt</router-link></li>
                                <li><a href="javascript:void(0)" v-on:click="del(user.id)"><i class="fa fa-trash"></i>Töröl</a></li>
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      users: []
    }
  },
  mounted: function() {
    this.getUsers();
  },
  methods: {
    getUsers: function() {
      var _this = this;

      this.$root.ajax('users/list', {
        success: function(response) {
          _this.users = response.users;
        }
      });
    },
    del: function(id) {
      var _this = this;

      this.$root.ajax('user/del/' + id, {
        success: function(response) {
          _this.getUsers();
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// users.vue?247d287e